package com.upcominds.expedite.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

// =============== Puzzle DTOs ===============

@Serializable
data class PuzzleCreateRequest(
    val name: String,
    val description: String? = null,
    val numberOfQuestions: Int = 10
)

@Serializable
data class PuzzleUpdateRequest(
    val name: String? = null,
    val description: String? = null,
    val numberOfQuestions: Int? = null
)

@Serializable
data class PuzzleDTO(
    val id: String,
    val name: String,
    val description: String? = null,
    val numberOfQuestions: Int = 0,
    val questions: List<PuzzleQuestionDTO>? = null
)

@Serializable
data class PuzzleQuestionCreateRequest(
    val text: String,
    val explanation: String? = null,
    val options: List<PuzzleOptionCreateRequest> = emptyList()
)

@Serializable
data class PuzzleOptionCreateRequest(
    val text: String,
    val points: Int,
    val isCorrect: Boolean
)

@Serializable
data class PuzzleQuestionDTO(
    val id: String,
    val text: String,
    val explanation: String? = null,
    val options: List<PuzzleOptionDTO> = emptyList()
)

@Serializable
data class PuzzleOptionDTO(
    val id: String,
    val text: String,
    val points: Int = 0,
    @SerialName("correct")
    val isCorrect: Boolean = false
)

@Serializable
data class PuzzleAttemptDTO(
    val attemptId: String,
    val puzzleId: String,
    val name: String,
    val description: String? = null,
    val questions: List<PuzzleUserQuestionDTO> = emptyList(),
    val completed: Boolean = false
)

@Serializable
data class PuzzleUserQuestionDTO(
    val id: String,
    val text: String,
    val options: List<PuzzleUserOptionDTO> = emptyList(),
    val selectedOptionId: String? = null,
    val explanation: String? = null
)

@Serializable
data class PuzzleUserOptionDTO(
    val id: String,
    val text: String
    // Hidden points and isCorrect
)

@Serializable
data class PuzzleResultDTO(
    val attemptId: String,
    val totalPoints: Int = 0,
    val maxPoints: Int = 0, // Sum of max points of presented questions
    val answers: List<PuzzleAnswerResultDTO> = emptyList()
)

@Serializable
data class PuzzleAnswerResultDTO(
    val questionId: String,
    val questionText: String,
    val selectedOptionId: String? = null,
    val selectedOptionText: String? = null,
    @SerialName("correct")
    val isCorrect: Boolean = false,
    val pointsAwarded: Int = 0,
    val explanation: String? = null,
    val options: List<PuzzleOptionDTO> = emptyList() // Show full details now
)

@Serializable
data class SubmitPuzzleAnswerRequest(
    val questionId: String,
    val optionId: String
)
